var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonAvatarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "692AECA2-30A4-48D2-8B8C-07547BC8E2D7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "#43DAD4",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-695.000000, -454.000000)",
    fill: "#43DAD4",
    fillRule: "nonzero",
    stroke: "#43DAD4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(696.000000, 455.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2,0 C9.1,0 0,9 0,20.2 C0,31.4 9,40.4 20.2,40.4 C31.4,40.4 40.4,31.4 40.4,20.2 C40.4,9 31.4,0 20.2,0 L20.2,0 Z M20.2,1.8 C30.3,1.8 38.5,10 38.5,20.1 C38.5,25 36.6,29.5 33.4,32.8 C31.8,27 26.5,22.8 20.2,22.8 C13.9,22.8 8.6,27 7,32.8 C3.8,29.5 1.9,25 1.9,20.1 C1.9,10 10.1,1.8 20.2,1.8 L20.2,1.8 Z M20.2,24.7 C26,24.7 30.8,28.8 31.9,34.3 C28.7,36.9 24.7,38.5 20.2,38.5 C15.7,38.5 11.7,36.9 8.5,34.3 C9.6,28.8 14.4,24.7 20.2,24.7 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2,7.5 C23.6793939,7.5 26.5,10.3206061 26.5,13.8 C26.5,17.2793939 23.6793939,20.1 20.2,20.1 C16.7206061,20.1 13.9,17.2793939 13.9,13.8 C13.9,10.3206061 16.7206061,7.5 20.2,7.5 Z M20.2,8.9 C17.5,8.9 15.3,11.1 15.3,13.8 C15.3,16.5 17.5,18.7 20.2,18.7 C22.9,18.7 25.1,16.5 25.1,13.8 C25.1,11.1 22.9,8.9 20.2,8.9 Z",
    id: "Combined-Shape",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAvatarIcon);
export default __webpack_public_path__ + "static/media/person-avatar-icon.28a3a053c22f09484b7b2d8ed730e1ab.svg";
export { ForwardRef as ReactComponent };